import React from "react";
import styled from "styled-components";
import { func } from "prop-types";
import { postcodeAdUnitClick } from "data/segmentCustomEvents";
import Copy from "components/shared/Copy";
import Button from "components/shared/Button";
import kitchen from "illustrations/kitchen/resp-supercarers-connecting-people-who-care2.png";

const BackgroundContainer = styled.div`
  background: ${({ theme }) => theme.colors.darkBlue};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 95%;
  max-height: 660px;
  max-width: 375px;
  padding: 1rem;

  @media (min-width: ${({ theme }) => theme.screen.tablet}px) {
    min-height: 400px;
    max-height: unset;
    max-width: unset;
    height: 100%;
    justify-content: space-between;
    border-radius: 7px;
  }
`;

const ImageContainer = styled.div`
  background: url(${kitchen}) no-repeat center;
  background-size: cover;
  height: 210px;
  width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
`;

const Step = styled.div`
  text-align: center;
  flex-basis: 33%;
  @media (min-width: ${({ theme }) => theme.screen.tablet}px) {
    flex: unset;
    padding: 0 1rem;
  }
`;

const BorderedStep = styled(Step)`
  @media (min-width: ${({ theme }) => theme.screen.tablet}px) {
    border-left: 1px solid grey;
    border-right: 1px solid grey;
  }
`;

const AdUnitPage = ({ setCurrentPage }) => {
  const submitEventAndChangePage = () => {
    postcodeAdUnitClick();
    setCurrentPage(2);
  };

  return (
    <BackgroundContainer>
      <Wrapper>
        <Copy color={"whiteSmoke"} width="100%" size={1.4} weight="700">
          Tell us about your needs
        </Copy>
        <Copy size={0.9} weight="600" width="100%">
          Find your perfect carer in a few simple steps
        </Copy>
        <ImageContainer />
        <Button
          background="red"
          onClick={submitEventAndChangePage}
          textColour="white"
          label="Begin First Step"
          padding="0.5rem 0.3rem"
          width="250px"
        />
        <StepsContainer>
          <Step>
            <Copy color="whiteSmoke" weight="700">
              1
            </Copy>
            <Copy color="whiteSmoke" size={0.6} weight="600">
              Enter Your Care Details
            </Copy>
          </Step>
          <BorderedStep>
            <Copy color="whiteSmoke" weight="700">
              2
            </Copy>
            <Copy color="whiteSmoke" size={0.6} weight="600">
              We Assess Your Needs
            </Copy>
          </BorderedStep>
          <Step>
            <Copy color="whiteSmoke" weight="700">
              3
            </Copy>
            <Copy color="whiteSmoke" size={0.6} weight="600">
              Review Your Care Matches
            </Copy>
          </Step>
        </StepsContainer>
      </Wrapper>
    </BackgroundContainer>
  );
};

AdUnitPage.propTypes = {
  setCurrentPage: func.isRequired
};

export default AdUnitPage;
